import {StyledGrid} from 'presentation/components';
import {ShortcutCard} from 'presentation/pages/private/home/components/ShortcutCard';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {SHORTCUTS_MY_HOSPITALIZATION_LIST} from './constants';

export const CardsGrid = () => {
	const navigate = useNavigate();
	const {isMobile} = useMediaQueries();

	return (
		<StyledGrid.Root spacing={1}>
			{SHORTCUTS_MY_HOSPITALIZATION_LIST.map(shortcut => (
				<StyledGrid.Item key={shortcut.title} xs={6} sm={6} md={6} lg={3} xl={3}>
					<ShortcutCard
						handleClick={() => navigate(shortcut.route)}
						dataTagId={shortcut.dataTagId}
						hasEmphasis={shortcut.isInverseColor}
						icon={shortcut.icon}
						title={shortcut.title}
						customFontSize={isMobile ? '14px' : '16px'}
						dataTestId={shortcut.dataTestId}
						breakTitle
					/>
				</StyledGrid.Item>
			))}
		</StyledGrid.Root>
	);
};
